module.exports = __webpack_public_path__ + "media/components/country-flag/static/je-fcdac9e825548adc58387968edcdeeab.svg";